/**
 * What a heading's own fields carry, which no section body holds: each `[connection]` heading, the `[editable]`
 * headings with no `path=`, and the `ExtResource` uses of a node's `instance=`. Only the linter asks, so the strict
 * parser collects them from `onSectionStart` and the shared scan never does.
 */
import { parseIdTrail } from '../../godot/scene/packedScene.js';
function connectionHeading({ attributes }, line) {
    return {
        line,
        signal: attributes.signal,
        from: attributes.from,
        to: attributes.to,
        method: attributes.method,
        binds: attributes.binds,
        fromIdTrail: parseIdTrail(attributes.from_uid_path),
        toIdTrail: parseIdTrail(attributes.to_uid_path),
    };
}
/** A collector to feed each parsed heading in scan order, and the reads it has gathered so far. */
export function headingReads() {
    const connections = [];
    const pathlessEditableLines = [];
    const instancesOutsideNodeBody = [];
    // Only a `[node]` body reads the heading after it leniently, so the previous heading's type decides.
    let previousHeadingType = null;
    return {
        reads: { connections, pathlessEditableLines, instancesOutsideNodeBody },
        read(heading, line) {
            const { instance } = heading.attributes;
            if (heading.type === 'connection')
                connections.push(connectionHeading(heading, line));
            if (heading.type === 'editable' && heading.attributes.path === undefined)
                pathlessEditableLines.push(line);
            if (heading.type === 'node' && previousHeadingType !== 'node' && instance !== undefined) {
                instancesOutsideNodeBody.push(instance);
            }
            previousHeadingType = heading.type;
        },
    };
}
//# sourceMappingURL=headingReads.js.map